<template>
  <div class="app-slider" :class="{ bg_gray: 'bg_gray' }">
    <div class="container">
      <div class="app-slider__inner">
        <div class="app-slider__slides-wrapper">
          <swiper ref="app_slider" :options="swiperOptions">
            <swiper-slide :key="i" v-for="(it, i) in cont">
              <div
                class="app-slider__slide-inner"
                :style="{
                  borderColor: it.border_color + 'BD',
                  boxShadow: '0px 0px 50px' + it.border_color + '66'
                }"
              >
                <div class="app-slider__img-wrapper">
                  <img
                    :src="it.image[0].url"
                    :alt="
                      $route.name == 'PageViewRouter_ge'
                        ? it.seo_keywords_ge
                        : it.seo_keywords_en
                    "
                  />
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="app-slider__pagination flex wc-lg column"></div>
        <div class="app-slider__text-box flex column">
          <transition name="transit-text-1" mode="out-in">
            <h2 class="f-38 bold uppercase wc-lg" :key="active_slide_data.id">
              {{ _.get(active_slide_data, "teaser") }}
            </h2>
          </transition>
          <transition name="transit-text-2" mode="out-in">
            <p class="f-14 regular wc-lg" :key="active_slide_data.id">
              {{ _.get(active_slide_data, "content") }}
            </p>
          </transition>
          <transition name="transit-text-3" mode="out-in">
            <a
              :href="_.get(active_slide_data, 'url')"
              class="button app-slider__button bg-light-purple wc-lg"
              :key="active_slide_data.id"
              target="_blank"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#fff"
                />
              </svg>
              <div class="app-slider__button--text-wrapper">
                <span class="bold f-14 uppercase f-white">
                  {{ _.get(active_slide_data, "button_name") }}</span
                >
              </div>
            </a>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contentData: {
      type: Object
    }
  },
  data() {
    let that = this;
    return {
      swiperOptions: {
        // Booleans

        loop: true,
        grabCursor: true,
        centeredSlides: true,
        watchOverflow: true,
        // Other Options
        slidesPerView: "auto",
        speed: 800,
        initialSlide: 1,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 70,
          depth: 230,
          modifier: 1,
          slideShadows: false
        },
        pagination: {
          el: ".app-slider__pagination",
          clickable: true,
          renderBullet(index, className) {
            return (
              '<div class="' +
              className +
              '"><span>' +
              that.cont[index].title +
              "</span></div>"
            );
          }
        },

        // Responsives
        breakpoints: {
          1024: {
            coverflowEffect: {
            stretch: 70,
            depth: 230,
            },
          },
          768: {
            coverflowEffect: {
            stretch: 70,
            depth: 270,
            },
          },
        },

        // Events
        f_slides: [],
        set_active_styles(act_idx, real_idx) {
          that.active_slide_data = {
            // title: that.
          };
          Object.assign(that.active_slide_data, that.cont[real_idx]);
          this.f_slides.forEach((el, idx, slides) => {
            if (idx === act_idx) {
              el.style.opacity = "1";
              setTimeout(() => {
                el.style.zIndex = "0";
              }, 10);
            } else if (idx === act_idx + 1 || idx === act_idx - 1) {
              el.style.opacity = "0.3";

              setTimeout(() => {
                el.style.zIndex = "0";
              }, 10);
            } else {
              // setTimeout(() => {
              setTimeout(() => {
                el.style.zIndex = "0";
              }, 10);
              // }, 1000);
              el.style.opacity = "0";
            }
          });
        },
        on: {
          init() {
            that.$nextTick(() => {
              let slides = document.querySelectorAll(
                ".app-slider .swiper-slide"
              );
              this.params.f_slides = slides;

              this.params.set_active_styles(this.activeIndex, this.realIndex);
            });
          },
          slideChange() {
            this.params.set_active_styles(this.activeIndex, this.realIndex);
          }
        }
      },
      active_slide_data: {}
    };
  },
  computed: {
    bg_gray() {
      return _.get(this.contentData, "conf.conf[0]");
    },
    cont() {
      return _.get(this.contentData, "data.list");
    }
  }
};
</script>

<style lang="sass">
.transit-text-1, .transit-text-2, .transit-text-3
    &-enter
        opacity: 0
        transform: translateY(70px)
        @media (max-width: 767px)
          transform: translateY(0)
        &-active
            transition: 0.8s cubic-bezier(0.33, 1, 0.68, 1)
        &-to
            opacity: 1
            transform: translateY(0)
    &-leave
        opacity: 1
        transform: translateY(0)
        &-active
            transition: 0.6s cubic-bezier(0.33, 1, 0.68, 1)
        &-to
            opacity: 0
            transform: translateY(-200px)
            @media (max-width: 1023px)
              transform: translateY(-78px)
            @media (max-width: 767px)
              transform: translateY(0)

.transit-text-2
    &-enter
        transform: translateY(20px)
        @media (max-width: 767px)
          transform: translateY(0)
        opacity: 0
        &-active
            transition-delay: .05s
            transition: .8s cubic-bezier(0.33, 1, 0.68, 1)
            @media (max-width: 767px)
              transition-delay: 0s
        &-to
            opacity: 1
            transform: translateY(0)
    &-leave
        opacity: 1
        transform: translateY(0)

        &-active
            transition-delay: .1s
            @media (max-width: 767px)
              transition-delay: 0s

.transit-text-3
    &-enter
        transform: translateY(0px) scale(0.8)
        opacity: 0
        svg
            transform: translateX(-10px)
            opacity: 0
        .app-slider__button--text-wrapper span
            transform: translateY(100%)
        &-active
            transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1) 
            transition-property: transform, opacity
            transition-duration: 1s, .1s
            transition-delay: .05s !important
            transform-origin: center
            @media (max-width: 767px)
              transition-delay: 0s !important
            .app-slider__button--text-wrapper  span
                transition: .4s cubic-bezier(0.33, 1, 0.68, 1)
            svg
                transition-delay: 1s
                transition: .4s cubic-bezier(0.33, 1, 0.68, 1)

        &-to
            opacity: 0
            transform: translateY(0) scale(0.8)
            .app-slider__button--text-wrapper span
                transform: translateY(0)
            svg
                transform: translateX(0)
                opacity: 1
    &-leave
        opacity: 1
        transform: translateY(0) scale(1)
        svg
            transform: translateX(0)
            opacity: 1
        .app-slider__button--text-wrapper span
            transform: translateY(0)
        &-active
            transition-delay: 0.12s !important
            @media (max-width: 767px)
              transition-delay: 0s !important



@keyframes title-anim
    from
        transform: translateX(0px)
    to
        transform: translateX(10px)
@keyframes title-border-anim
    from
        transform: scaleY(0)
        transform-origin: center
        background-color: transparent
    to
        transform: scaleY(24px)
        transform-origin: center
        background-color:  #6D6E70


.app-slider
    position: relative
    padding-top: 76px
    padding-bottom: 73px
    background-color: white
    &__button
        width: fit-content
        padding: 20px 30px
        margin-top: 47px
        transition: .4s
        @media (min-width: 1024px)
          &:hover 
            background-color: #613dd1
        &--text-wrapper
            position: relative
            display: block
            overflow: hidden
            span
                display: block
    &__pagination
        position: absolute
        top: 0
        left: 0
        margin-top: 357px
        z-index: 10
    .swiper-pagination-bullet
        position: relative
        height: fit-content
        width: 219px
        display: block
        background: transparent
        transition: .5s
        margin-bottom: 18px
        &:after
            position: absolute
            top: 0
            left: 0
            content: ''
            height: 24px
            width: 2px
            background-color: transparent
            border-radius: 1px
            transition: .5s
        span
            will-change: transform
            display: block

        &-active
            background: transparent
            &:after
                animation: title-border-anim .5s forwards


            span
                animation: title-anim .5s forwards
                font-family: "TBCSailec-Bold"

    &__inner
        position: relative
    &__text-box
        position: absolute
        z-index: 10
        top: 0
        right: 0
        width: 353px
        height: 100%
        padding-top: 229px
        p
            margin-top: 25px


    &__img-wrapper
        position: relative
        height: 100%
        overflow: hidden

        img
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            object-fit: cover
    &__slides-wrapper
        position: relative
        width: 484px
        height: 750px
        overflow: visible
        margin-left: 224px

    &__slide-inner
        position: relative
        transition: transform 0.8s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.3s
        border-width: 5px
        border-style: solid
        border-radius: 15px
        overflow: hidden
        height: 100%

    .swiper-container
        height: 100%
        padding-top: 150px
        overflow: visible

    .swiper-slide
        background-color: transparent
        width: 239px
        height: 506px
        transition: .8s

        &-active
            .app-slider__slide-inner
                transform: scale(1)
        &-duplicate-active
            .app-slider__slide-inner
                transform: scale(1)
    @media (max-width: 1206px)
      .f-38 
        font-size: 24px
        line-height: 32px
      &__pagination 
        display: none
      &__inner 
        display: flex
        justify-content: center
      &__text-box
        position: relative
        margin-left: 57px
        padding-top: 50px
      &__slides-wrapper 
        margin-left: 0
        height: 506px
      .swiper-container
        padding-top: 0
    @media (max-width: 1023px)
      padding-bottom: 55px
      &__slides-wrapper 
        width: 280px
        height: 342px
      &__inner
        height: 342px
        justify-content: center
        p 
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;  
          overflow: hidden;
      &__text-box
        margin-top: 50px
        margin-left: 55px
        padding-top: 0
        overflow: visible
      &__button
        margin-top: 21px
      .swiper-slide 
        width: 157px
        height: 342px
      .swiper-container 
        padding-top: 0
    @media (max-width: 767px)
      padding-bottom: 55px
      padding-top: 55px
      &__slides-wrapper 
        width: 280px
        height: 342px
      &__inner
        flex-direction: column
        align-items: center
        height: 650px
        p 
          -webkit-line-clamp: 5
      &__text-box
        margin-top: 34px
        margin-left: 0
        padding-top: 0
        display: flex
        align-items: center
        overflow: hidden
        h2, p
          text-align: center
      &__button
        margin-top: 21px
      .swiper-slide 
        width: 157px
        height: 342px
      .swiper-container 
        padding-top: 0
      

</style>
